"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slideFullSizeVideoLayout = exports.slideDoubleColumnTextLayout = exports.slideDoubleColumnImageLayout = exports.slideImageRightLayout = exports.slideImageLeftLayout = exports.slideImageTopLayout = exports.slideTitleWithBodytextLayout = exports.slideCoverLayout = exports.slideImageOnly = exports.slideBlankLayout = void 0;
const helpers_1 = require("../helpers");
const tip_tap_1 = require("../tip-tap");
function slideBlankLayout({ backgroundColor = '#ffffff' }) {
    return {
        key: 'BLANK',
        backgroundColor,
        layoutParts: {},
        pinComponents: [],
    };
}
exports.slideBlankLayout = slideBlankLayout;
function slideImageOnly({ backgroundColor = '#ffffff', backgroundImage, }) {
    return {
        key: 'IMAGE_ONLY',
        backgroundColor,
        layoutParts: {},
        pinComponents: [],
        backgroundImage,
    };
}
exports.slideImageOnly = slideImageOnly;
function slideCoverLayout({ title, body, backgroundColor = '#ffffff', }) {
    return {
        key: 'COVER',
        backgroundColor,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(896, 234),
                content: title?.content ||
                    (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['cover.title'], {
                        bold: true,
                    }),
                settings: {
                    textStyleKey: 'title',
                    horizontalAlignment: 'center',
                    verticalAlignment: 'end',
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '48px',
                    ...title?.settings,
                },
                order: 'a0',
            }),
            BODYTEXT1: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 274),
                size: (0, helpers_1.newSize)(896, 234),
                content: body?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['cover.body']),
                settings: {
                    textStyleKey: 'body',
                    fontSize: '24px',
                    fontFamily: 'DM Sans',
                    horizontalAlignment: 'center',
                    verticalAlignment: 'baseline',
                    ...body?.settings,
                },
                order: 'a1',
            }),
        },
        pinComponents: [],
    };
}
exports.slideCoverLayout = slideCoverLayout;
function slideTitleWithBodytextLayout({ title, body, backgroundColor = '#ffffff', }) {
    return {
        key: 'TITLE_TOP_WITH_BODYTEXT',
        backgroundColor,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(896, 60),
                content: title?.content ||
                    (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.title'], {
                        bold: true,
                    }),
                settings: {
                    ...(0, helpers_1.defaultTemplateTextSettingsForType)('title'),
                    ...title?.settings,
                },
                order: 'a0',
            }),
            BODYTEXT1: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 124),
                size: (0, helpers_1.newSize)(896, 384),
                content: body?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.body']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)(), ...body?.settings },
                order: 'a1',
            }),
        },
        pinComponents: [],
    };
}
exports.slideTitleWithBodytextLayout = slideTitleWithBodytextLayout;
function slideImageTopLayout({ title, imageUrl = '', backgroundColor = '#ffffff', }) {
    return {
        key: 'IMAGE_TOP',
        backgroundColor,
        layoutParts: {
            IMAGE1: (0, helpers_1.newImagePinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(896, 384),
                order: 'a0',
                url: imageUrl,
            }),
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 448),
                size: (0, helpers_1.newSize)(896, 60),
                content: title?.content ||
                    (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.title'], {
                        bold: true,
                    }),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)('title'), ...title?.settings },
                order: 'a1',
            }),
        },
        pinComponents: [],
    };
}
exports.slideImageTopLayout = slideImageTopLayout;
function slideImageLeftLayout({ title, body, backgroundColor = '#ffffff', imageUrl = '', }) {
    return {
        key: 'IMAGE_LEFT',
        backgroundColor,
        layoutParts: {
            IMAGE1: (0, helpers_1.newImagePinComponent)({
                position: (0, helpers_1.newVector)(0, 0),
                size: (0, helpers_1.newSize)(480, 540),
                order: 'a0',
                url: imageUrl,
            }),
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(512, 32),
                size: (0, helpers_1.newSize)(416, 60),
                content: title?.content ||
                    (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.title'], {
                        bold: true,
                    }),
                settings: {
                    ...(0, helpers_1.defaultTemplateTextSettingsForType)('title'),
                    ...title?.settings,
                },
                order: 'a1',
            }),
            BODYTEXT1: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(512, 108),
                size: (0, helpers_1.newSize)(416, 400),
                content: body?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.body']),
                settings: {
                    ...(0, helpers_1.defaultTemplateTextSettingsForType)(),
                    ...body?.settings,
                },
                order: 'a2',
            }),
        },
        pinComponents: [],
    };
}
exports.slideImageLeftLayout = slideImageLeftLayout;
function slideImageRightLayout({ title, body, backgroundColor = '#ffffff', imageUrl = '', }) {
    return {
        key: 'IMAGE_RIGHT',
        backgroundColor,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(416, 60),
                content: title?.content ||
                    (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.title'], {
                        bold: true,
                    }),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)('title'), ...title?.settings },
                order: 'a0',
            }),
            BODYTEXT1: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 108),
                size: (0, helpers_1.newSize)(416, 400),
                content: body?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.body']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)(), ...body?.settings },
                order: 'a1',
            }),
            IMAGE1: (0, helpers_1.newImagePinComponent)({
                position: (0, helpers_1.newVector)(480, 0),
                size: (0, helpers_1.newSize)(480, 540),
                order: 'a2',
                url: imageUrl,
            }),
        },
        pinComponents: [],
    };
}
exports.slideImageRightLayout = slideImageRightLayout;
function slideDoubleColumnImageLayout({ textOne, textTwo, backgroundColor = '#ffffff', imageOne = '', imageTwo = '', }) {
    return {
        key: 'BODYTEXT_AND_IMAGE_TWO_COLUMNS',
        backgroundColor,
        layoutParts: {
            IMAGE1: (0, helpers_1.newImagePinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(432, 436),
                order: 'a1',
                url: imageOne,
            }),
            IMAGE2: (0, helpers_1.newImagePinComponent)({
                position: (0, helpers_1.newVector)(496, 32),
                size: (0, helpers_1.newSize)(432, 436),
                order: 'a2',
                url: imageTwo,
            }),
            BODYTEXT1: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 468),
                size: (0, helpers_1.newSize)(432, 40),
                content: textOne?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.body']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)(), ...textOne?.settings },
                order: 'a3',
            }),
            BODYTEXT2: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(496, 468),
                size: (0, helpers_1.newSize)(432, 40),
                content: textTwo?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.body']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)(), ...textTwo?.settings },
                order: 'a4',
            }),
        },
        pinComponents: [],
    };
}
exports.slideDoubleColumnImageLayout = slideDoubleColumnImageLayout;
function slideDoubleColumnTextLayout({ title, subTitleOne, textOne, subTitleTwo, textTwo, backgroundColor = '#ffffff', }) {
    return {
        key: 'BODYTEXT_TWO_COLUMNS',
        backgroundColor,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(896, 56),
                content: title?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['slide.body']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)('title'), ...title?.settings },
                order: 'a0',
            }),
            SUBTITLE1: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 120),
                size: (0, helpers_1.newSize)(432, 45),
                content: subTitleOne?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['column.title']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)('subtitle'), ...subTitleOne?.settings },
                order: 'a1',
            }),
            BODYTEXT1: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 175),
                size: (0, helpers_1.newSize)(432, 335),
                content: textOne?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['column.body']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)(), ...textOne?.settings },
                order: 'a1',
            }),
            SUBTITLE2: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(496, 120),
                size: (0, helpers_1.newSize)(432, 45),
                content: subTitleTwo?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['column.title']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)('subtitle'), ...subTitleTwo?.settings },
                order: 'a1',
            }),
            BODYTEXT2: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(496, 175),
                size: (0, helpers_1.newSize)(432, 335),
                content: textOne?.content || (0, tip_tap_1.stringToProsemirror)(helpers_1.fallbackCopy['column.body']),
                settings: { ...(0, helpers_1.defaultTemplateTextSettingsForType)(), ...textTwo?.settings },
                order: 'a1',
            }),
        },
        pinComponents: [],
    };
}
exports.slideDoubleColumnTextLayout = slideDoubleColumnTextLayout;
function slideFullSizeVideoLayout({ backgroundColor = '#ffffff', }) {
    return {
        key: 'VIDEO_ONLY',
        backgroundColor,
        layoutParts: {
            VIDEO: (0, helpers_1.newVideoPinComponent)({
                size: (0, helpers_1.newSize)(960, 540),
                position: (0, helpers_1.newVector)(0, 0),
            }),
        },
        pinComponents: [],
    };
}
exports.slideFullSizeVideoLayout = slideFullSizeVideoLayout;
//# sourceMappingURL=slide-templates.js.map